import { render, staticRenderFns } from "./CustomersBalanceReportView.vue?vue&type=template&id=4ea66fc0"
import script from "./CustomersBalanceReportView.vue?vue&type=script&lang=js"
export * from "./CustomersBalanceReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports